import { render, staticRenderFns } from "./QuoteOrm.vue?vue&type=template&id=6cbd35ca&scoped=true"
import script from "./QuoteOrm.vue?vue&type=script&lang=js"
export * from "./QuoteOrm.vue?vue&type=script&lang=js"
import style0 from "./QuoteOrm.vue?vue&type=style&index=0&id=6cbd35ca&prod&lang=scss&scoped=true"
import style1 from "./QuoteOrm.vue?vue&type=style&index=1&id=6cbd35ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbd35ca",
  null
  
)

export default component.exports